import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStudent } from 'models/user';
import UserMe from 'services';
import SignIn from '../../pages/login/signIn';


export type TypeInitialStateUser = {
    user: IStudent | null,
    isLoading: boolean
}

const initialState: TypeInitialStateUser = {
    user: null,
    isLoading: false
}


const UserSlice: any = createSlice({
    name: "user",
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(UserMe.pending, (state, action: PayloadAction<any>) => {
                state.isLoading = true
            })
            .addCase(UserMe.fulfilled, (state, action: PayloadAction<any>) => {
                if (action.payload && action?.payload?.status === 1) {
                    state.user = action.payload.data
                    state.isLoading = false
                } else {
                    state.isLoading = false
                }
            })
            .addCase(UserMe.rejected, (state, action: PayloadAction<any>) => {
                if (action?.payload?.data?.status === 0) {
                    state.isLoading = false
                } else {
                    state.isLoading = false
                }
            })
    }
})


export const USER_ACTIONS = UserSlice.actions;
export default UserSlice;


